
import './App.css';
import {
  Route,
  Switch,

} from "react-router-dom";
import "antd/dist/antd.css";
import swal from "sweetalert";
import Logo from './components/Images/logoMinhQuan.png';
import { Col, Divider, Layout, Row, Card, Image, Space, Input, Button, Badge, Modal, BackTop, List, Avatar, Tag } from 'antd';
import {
  BellOutlined, HomeOutlined, PhoneOutlined, MailOutlined, RightCircleOutlined, FacebookOutlined, AliwangwangOutlined, AimOutlined, FormOutlined, DeleteOutlined,
  CiCircleOutlined
} from "@ant-design/icons";
import { useLocation, Link, useHistory, withRouter } from "react-router-dom";
import Login from './components/Login/login';
import HeaderView from './components/Header/header';
import { logout } from './actions/auth';
import { useDispatch, useSelector } from "react-redux";
import { SiZalo } from "react-icons/si";
import { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import AdminPage from './components/AdminPage/adminpage';
import logoMinhquan from './components/Images/logoMinhQuan.png'
import Decentralization from './components/Decentralization/decentralization';
import { isMobile } from 'react-device-detect';

import SearchBar from './components/SearchBar/searchBar';
import BlankPage from './components/Blank/blank';
import AuthVerify from './services/authVerify';
import Manager from './components/Manager/manager';
import Customer from './components/Customer/customer';
import MainBanner from './components/MainBanner/mainbanner';
import Home from './components/Home/home';
import Views from './components/View/view';
import HeaderAdmin from './components/Header/headerAdmin';
import HomeAdminPage from './components/HomeAdmin/homeadmin';
import Content from './components/Content/content';
import MenuAdmin from './components/MenuAdmin/menuadmin';
import Members from './components/Members/members';
import MemberView from './components/View/memberview';
import WebsiteManager from './components/Banner/banner';
import CategoryView from './components/View/categoryView';
import axiosClient from './api/axios';
import LinkUpload from './api/LinkUpload';
import CompanyManager from './components/CompanyInfo/companyinfo';
import FacebookCard from './components/FacebookCard/facebookcard';
import ViewIntroduction from './components/View/viewIntroduction';
import ContactSection from './components/ContractCard/ContactCard';
import OrganizationsView from './components/View/Organizations';
import PageHeader from './components/PageHeader/PageHeader';
import News from './components/View/News';
import MarqueeManager from './components/Marquee/Marquee';


const dataMenu = [
  {
    label: 'Menu',
    value: '/adminpage/managermenu'
  },
  {
    label: 'Nội dung',
    value: '/adminpage/managercontent'
  },
]
const { Search } = Input;

function App() {
  const history = useHistory()
  const location = useLocation();
  const pathName = location.pathname.split('/')

  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const IDAccount = localStorage.getItem('ID');
  const role = localStorage.getItem('Role');
  const token = localStorage.getItem('token');
  const [visible, setVisible] = useState(false);

  const header = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleLogout = useCallback(() => {
    dispatch(logout());
    swal("Đăng xuất thành công", {
      buttons: false,
      icon: "success",
    });
    window.location.href = "/";
  }, [dispatch]);
  const [dataCategories, setDataCategories] = useState([
    {
      "ID": 1,
      "Name": "",
      "Slug": "",
      "Description": ""
    },

  ])
  const LoadDataCategories = () => {
    axiosClient.post('/Categories/GetCategoriesAll', '', {
      headers: header
    }).then(res => {
      setDataCategories(res.data.filter(i => i.Active === true).sort(function (a, b) { return a.Position - b.Position }))
    })
  }
  const [dataOwners, setDataOwners] = useState({
    "ID": 1,
    "OwnerName": "",
    "Address": "",
    "Phone": "",
    "Email": "",
    "Logo": "",
    "Googlemap": "",
    "Zalo": "",
    "Facebook": ""
  })
  const LoadDataOwners = () => {
    axiosClient.post('/Owners/GetOwnersAll', '', { headers: header }).then(res => {
      setDataOwners(res.data[0])
    })
  }
  const [dataMenus, setDataMenus] = useState([

  ])
  const LoadDataMenus = () => {
    axiosClient.post('/Menus/GetMenusAll', '', {
      headers: header
    }).then(res => {
      setDataMenus(res.data.filter(i => i.Active === true).sort(function (a, b) { return a.Position - b.Position }))
    })
  }
  useEffect(() => {
    LoadDataMenus()
    LoadDataOwners()
    LoadDataCategories()
  }, [])
  const showModalNotification = (e) => {
    setVisible(true);
  }

  const { pathname } = location;
  const { breadcrumbs, pageTitle } = useMemo(() => {
    if (!dataMenus) return { breadcrumbs: [], pageTitle: '' };

    const menuMapById = new Map(dataMenus.map(item => [item.ID, item]));
    const currentItem = dataMenus.find(item => item.Url === pathname);
    if (!currentItem) return { breadcrumbs: [], pageTitle: '' };

    const path = [];
    let tempItem = currentItem;
    while (tempItem) {
      path.unshift(tempItem);
      tempItem = menuMapById.get(tempItem.IDParent);
    }
    path.unshift({ ID: 'home', Title: 'Trang chủ', Url: '/' });
    const title = path.length > 0 ? path[path.length - 1].Title : '';
    return { breadcrumbs: path, pageTitle: title };
  }, [pathname, dataMenus]);

  // Logic để quyết định có hiển thị disclaimer hay không
  const shouldShowDisclaimer = ['/thanh-vien', '/to-chuc-hanh-nghe'].includes(pathname);
  const renderHeader = () => {
    return (
      <div>
        {pathName[1] === 'adminpage' && isLoggedIn === true ? <div style={{ backgroundColor: '#F0F2F5' }}>
          <Row>
            <Col xs={24} xl={24} span={24}>
              <Card bodyStyle={{ textAlign: 'center', alignItems: 'center', margin: 'auto', paddingTop: 10 }} size='small'>
                <Row>
                  <Col xs={0} xl={8} style={{ left: 0 }} span={8}>
                    <Space onClick={(e) => window.location.href = '/adminpage'} align="center">
                      <Image style={{ height: 60, width: 50, left: 0 }} preview={false} src={logoMinhquan} />
                      <strong style={{ color: '003399', fontSize: 20 }}>{'Minh Quân Computer'}</strong>
                    </Space>
                  </Col>
                  <Col xs={14} xl={0} style={{ left: 0, textAlign: 'left' }} span={8}>
                    <Space onClick={(e) => window.location.href = '/adminpage'} align="left">
                      <Image style={{ height: 60, width: 50, left: 0 }} preview={false} src={logoMinhquan} />
                      <strong style={{ color: '003399', fontSize: 20 }}>{'Minh Quân Computer'}</strong>
                    </Space>
                  </Col>
                  <Col xs={0} xl={8} style={{ marginTop: 13 }} span={8}>
                    {SearchBar(dataMenu)}
                  </Col>
                  <Col xs={10} xl={8} style={{ marginTop: 13 }} span={8}>
                    <Space>
                      <Row gutter={[16, 16]}>
                        <Col span={4}>
                          <Button.Group >
                            <Button onClick={(e) => showModalNotification(e)} style={{ borderRadius: 2 }} icon={<Badge count={0}>
                              <BellOutlined style={{ fontSize: '110%', color: '#003399' }} />
                            </Badge>}>
                            </Button>
                          </Button.Group>
                        </Col>
                        <Col style={{ marginTop: 5 }} span={20}>
                          Không có thông báo
                        </Col>
                      </Row>
                    </Space>

                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
          <HeaderAdmin />
        </div> : <HeaderView dataMenus={dataMenus} />}
      </div>
    )
  }
  const categorymember = dataCategories.find(i => i.ID === 6);
  const categoryOrganizations = dataCategories.find(i => i.ID === 25);



  return (
    <div className="noselect">
      <div style={{ overflowX: isMobile ? 'hidden' : 'unset' }} className='App'>

        {pathName[1] === 'login' ? null : <div style={{ backgroundColor: '#F0F2F5' }}>
          {renderHeader()}

        </div>}

        {pathName[1] !== 'login' && pathName[1] !== 'adminpage' && pathName[1] !== 'view' && (
          <PageHeader
            breadcrumbs={breadcrumbs}
            pageTitle={pageTitle}
            showDisclaimer={shouldShowDisclaimer}
          />
        )}
        <div style={{ minHeight: 570 }}>
          <Switch>
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'13'} path={'/adminpage/marquee'}><MarqueeManager /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'13'} path={'/adminpage/managercompany'}><CompanyManager /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'12'} path={'/adminpage/managerbanner'}><WebsiteManager /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'11'} path={'/adminpage/members'}><Members /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'10'} path={'/adminpage/managermenu'}><MenuAdmin /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'9'} path={'/adminpage/managercontent'}><Content /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'8'} path={'/adminpage/customer'}><Customer /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'7'} path={'/adminpage/decentralization'}>{String(role).toLowerCase() === 'admin' ? <Decentralization /> : null}</Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'6'} path={'/adminpage/manageraccount'}>{String(role).toLowerCase() === 'admin' ? <AdminPage /> : null}</Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route key={'5'} path={'/adminpage/manager'}><Manager /></Route> : null}
            {isLoggedIn && pathName[1] === 'adminpage' ? <Route exact={true} key={'4'} path={'/adminpage'}><HomeAdminPage /></Route> : null}

            <Route
              key={'memberlist'}
              path={'/thanh-vien' || `/${categorymember.Slug}`} // Điều chỉnh path tùy theo ID 
            >
              <MemberView />
            </Route>
            <Route
              key={'ban-chu-nhiem'}
              path={'/to-chuc-hanh-nghe' || `/${categoryOrganizations.Slug}`} // Điều chỉnh path tùy theo ID 
            >
              <OrganizationsView />
            </Route>
            <Route
              key={'tin-moi-nhat'}
              path={'/tin-moi-nhat' || `/${categoryOrganizations.Slug}`} // Điều chỉnh path tùy theo ID 
            >
              <News />
            </Route>
            <Route key={'viewCategory'} path={'/category/:content'}><CategoryView /></Route>
            <Route key={'introduction'} path={'/introduction'}><ViewIntroduction /></Route>
            <Route key={'3'} path={'/view/:content'}><Views /></Route>
            <Route key={'2'} path={'/login'}><Login /></Route>
            <Route key={'1'} path={'/'}><Home /></Route>

          </Switch>

        </div>
        {pathName[1] === 'login' || pathName[1] === 'register' || pathName[1] === 'adminpage' ? null : <ContactSection data={dataOwners} />}
        {
          pathName[1] === 'login' || pathName[1] === 'register' || pathName[1] === 'forgotpassword' ? null : <div className='footer' style={{ textAlign: 'center', height: 50, overflow: 'hidden', backgroundColor: '#CCCCCC' }}>
            <Row>
              <Col style={{ paddingTop: 12 }} span={24}>
                <b style={{ fontSize: 14, fontFamily: 'Quicksand' }} className='textFooter'>©2025 Luat Su Lam Dong. Powered by Minh Quan Da Lat </b>
              </Col>
            </Row>
          </div>
        }
        <AuthVerify logOut={handleLogout} />
        <BackTop />
      </div >
    </div>

  );
}

export default App;
